class StatsVideo extends HTMLElement {
    constructor() {
        super();
        this.stats = this.querySelectorAll('.stats-video__stat');
        this.initObserver();
    }

    initObserver() {
        if (!this.stats.length) return;

        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                // Trigger animation when stat comes into view
                if (entry.isIntersecting) {
                    const statEl = entry.target;
                    if (!statEl.classList.contains('is-animated')) {
                        this.animateStat(statEl);
                        statEl.classList.add('is-animated');
                    }
                }
            });
        }, { threshold: 0.1 });

        this.stats.forEach(stat => this.observer.observe(stat));
    }

    animateStat(statEl) {
        const targetEl = statEl.querySelector('.stats-video__stat-number');
        const targetNumber = parseInt(statEl.dataset.target, 10);
        const duration = 1500; // Animation duration in ms
        const startTime = performance.now();

        const updateCounter = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);

            // Easing out cubic for realistic counting slowdown
            const easeOut = 1 - Math.pow(1 - progress, 3);

            const currentNumber = Math.floor(easeOut * targetNumber);
            if (targetEl) targetEl.textContent = currentNumber;

            if (progress < 1) {
                requestAnimationFrame(updateCounter);
            } else {
                if (targetEl) targetEl.textContent = targetNumber; // Ensure exact finish point
            }
        };

        requestAnimationFrame(updateCounter);
    }
}

if (!customElements.get('stats-video')) {
    customElements.define('stats-video', StatsVideo);
}
